var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_4438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9668 4.82769C6.9668 3.58464 7.98069 2.57422 9.22027 2.57422C10.4599 2.57422 11.4737 3.58811 11.4737 4.82769V7.08116H13.6612V4.82769C13.6612 2.36936 11.6612 0.386719 9.22027 0.386719C6.7793 0.386719 4.7793 2.37283 4.7793 4.82769V7.08116H6.9668V4.82769Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2441 7.8125H4.19553C3.53234 7.8125 2.99414 8.35417 2.99414 9.01389V16.184C2.99414 16.8472 3.53581 17.3854 4.19553 17.3854H14.2546C14.9178 17.3854 15.4559 16.8438 15.4559 16.184V9.01389C15.4594 8.35069 14.9178 7.8125 14.2441 7.8125ZM10.2059 14.7396H8.23372L8.62609 12.6458C8.28928 12.4444 8.04622 12.066 8.04622 11.6458C8.04622 10.9965 8.574 10.4722 9.21983 10.4722C9.86567 10.4722 10.3934 11 10.3934 11.6458C10.3934 12.0764 10.1643 12.441 9.81359 12.6458L10.2059 14.7396Z",
    fill: "#7F7F7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_4438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.724609 0.625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c5ad74406e80d55b15e71af804eb1f78.svg";
export { ForwardRef as ReactComponent };